import {
  SET_DATA_PRODUCTS_SCROLL,
  ScrollProductsState,
  ScrollProductsActions,
  SET_DATA_PRODUCTS_SCROLL_RESET,
  InitialState,
} from './types'

const ScrollMobileProductsReducer = (
  state: ScrollProductsState = InitialState,
  action: ScrollProductsActions
): ScrollProductsState => {
  switch (action.type) {
    case SET_DATA_PRODUCTS_SCROLL: {
      return {
        ...state,
        dataProducts: action.payload,
      }
    }
    case SET_DATA_PRODUCTS_SCROLL_RESET: {
      return {
        ...state,
        dataProducts: null,
      }
    }
    default:
      return state
  }
}

export default ScrollMobileProductsReducer
